export const CELL_IDENTITY_ATTRIBUTE = 'data-table-cell-identity';
